import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Check from '@material-ui/icons/Check';
import SmartphoneIcon from '@material-ui/icons/Smartphone';
import TextsmsIcon from '@material-ui/icons/Textsms';
import CreateIcon from '@material-ui/icons/Create';
import StepConnector from '@material-ui/core/StepConnector';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import {
  forgetpassOTP,
  validateForgetOTP,
  clearValidateOTP,
} from '../../Actions/OTPAcion';

import { forceChange, login } from '../../Actions/AuthAction';
import { Redirect, Link } from 'react-router-dom';

import Spinners from '../layout/Spinners';

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundImage: 'linear-gradient(270deg,rgba(252, 120, 213, 1) 0%,rgba(159, 5, 123, 1) 100%)',
    },
  },
  completed: {
    '& $line': {
      backgroundImage: 'linear-gradient(270deg,rgba(252, 120, 213, 1) 0%,rgba(159, 5, 123, 1) 100%)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundImage: 'linear-gradient(270deg,rgba(252, 120, 213, 1) 0%,rgba(159, 5, 123, 1) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed: {
    backgroundImage: 'linear-gradient(270deg,rgba(252, 120, 213, 1) 0%,rgba(159, 5, 123, 1) 100%)',
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SmartphoneIcon />,
    2: <TextsmsIcon />,
    3: <CreateIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}
ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

class ForgetPass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      steps: ['กรอกเบอร์มือถือ', 'กรอกรหัส OTP', 'กรอกข้อมูล'],
      number: '',
      otp: '',
      errorCode: '',
      password: '',
      passwordConfirm: '',
      errorPassword: '',
      statusButton: false,
    };
  }

  getStepContent(step) {
    const activeStep = this.state.activeStep - 1;
    switch (step) {
      case 0:
        return this.step1();
      case 1:
        return !this.props.otp.dataRegisterForget
          ? this.stepWait()
          : this.props.otp.dataRegisterForget?.code === '999999'
          ? this.step2()
          : this.setState({
              activeStep,
              otpError: `ไม่สามารถใช้เบอร์นี้ได้ กรุณาติดต่อ Call center`,
            });
      case 2:
        return !this.props.otp.dataValidate
          ? this.stepWait()
          : this.props.otp?.dataValidate?.code === '999999'
          ? this.step3()
          : this.setState({
              activeStep,
              errorCode: this.props.otp?.dataValidate?.message,
            });
      case 3:
        return this.stepFinish();
      default:
        return 'ไม่พบรายการ';
    }
  }

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  stepWait() {
    return (
      <div className="container">
        <div className="mt-3 row">
          <div className="col-5 ">กรุณารอสักครู่</div>
        </div>
      </div>
    );
  }

  stepFinish() {
    return (
      <div className="container">
        <div className="mt-3 row">
          <div className="col-12 mt-3">
            <div className="row justify-content-center">
              <div className="col-3 text-center ">Username : </div>
              <div className="col-5">{this.state.number}</div>
            </div>
          </div>
          <div className="col-12 mt-3">
            <div className="row justify-content-center">
              <div className="col-3 text-center ">Password : </div>
              <div className="col-5">{this.state.password}</div>
            </div>
          </div>
          <div className="col-12 text-center text-danger mt-4">
            ** Username เเละ Password นี้ใช้ในการเข้าใช้งานเว็บ Member เท่านั่น
            **
          </div>
        </div>
      </div>
    );
  }

  OtpAgain() {
    this.props.forgetpassOTP(this.state.number);
    console.log(this.state.number);
    alert('ท่านได้ขอ OTP ใหม่เรียบร้อยเเล้ว');
  }

  step1() {
    return (
      <div>
        <div className="mt-3">
          <div>เบอร์โทรศัพท์ : </div>
          <input
            required={true}
            type="number"
            className="col-12 form-control mt-2"
            name={'number'}
            value={this.state.number}
            placeholder="ตัวอย่าง 0812345678"
            onChange={e => this.onChange(e)}
          ></input>
          {this.state.otpError ? (
            <div className="text-danger text-center">
              {this.state.otpError}{' '}
              <a href="https://lin.ee/lBRkesz">
                https://lin.ee/lBRkesz (คลิ๊ก)
              </a>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
  step2() {
    return (
      <div>
        <div className="mt-3">
          <div>OTP : </div>
          <input
            required="true"
            type="number"
            className="col-12 form-control mt-2"
            name={'otp'}
            value={this.state.otp}
            placeholder="กรอก OTP ที่ท่านได้รับ"
            onChange={e => this.onChange(e)}
          ></input>
          <div className="col-12 text-center text-button mt-1">
            <button
              type="button"
              className="btn"
              onClick={() => this.OtpAgain()}
            >
              ขอ OTP อีกครั้ง
            </button>
          </div>
          <div className="text-danger mt-2">{this.state.errorCode}</div>
        </div>
      </div>
    );
  }
  step3() {
    return (
      <div>
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            <div>รหัสผ่านใหม่ :</div>
            <input
              required="true"
              type="password"
              className="col-12 form-control mt-2"
              name={'password'}
              value={this.state.password}
              placeholder="รหัสผ่านอย่างน้อย 8 ตัวอักษร"
              onChange={e => this.onChange(e)}
            ></input>
          </div>
          <div className="col-12 col-md-10 mt-3">
            <div>ยืนยันรหัสผ่านใหม่ :</div>
            <input
              required="true"
              title="5 to 10 characters"
              type="password"
              className="col-12 form-control mt-2"
              name={'passwordConfirm'}
              value={this.state.passwordConfirm}
              placeholder="ยืนยันรหัสผ่าน"
              onChange={e => this.onChange(e)}
            ></input>
            <div className="text-danger">{this.state.errorPassword}</div>
          </div>
        </div>
      </div>
    );
  }
  onSubmitForget = async e => {
    e.preventDefault();
    const activeStep = this.state.activeStep + 1;
    this.setState({
      statusButton: true,
    });
    if (this.state.activeStep === 0) {
      await this.props.forgetpassOTP(this.state.number);
      await this.setState({
        activeStep,
        statusButton: this.props.otp.statusButton,
      });
    } else if (this.state.activeStep === 1) {
      await this.props.clearValidateOTP();
      await this.props.validateForgetOTP(this.state.number, this.state.otp);
      this.setState({
        activeStep,
        statusButton: this.props.otp.statusButton,
      });
    } else if (this.state.activeStep === 2) {
      if (this.state.password === this.state.passwordConfirm) {
        if (this.state.password.length >= 8) {
          const tempDetail = {
            telNumber: this.state.number,
            newPassword: this.state.password,
          };
          await this.setState({
            errorPassword: '',
            activeStep,
            statusButton: this.props.otp.statusButton,
          });
          await this.props.forceChange(tempDetail);
          await this.props.login(this.state.number, this.state.password);
        } else {
          this.setState({
            errorPassword: 'Password อย่างน้อย 8 ตัวอักษร',
          });
        }
      } else {
        this.setState({
          errorPassword: 'Password ไม่ตรงกัน',
        });
      }
    } else if (this.state.activeStep === 3) {
      return <Redirect to="/test" />;
    }
  };

  render() {
    console.log(this.props.otp.dataRegisterForget);
    return (
      <form onSubmit={e => this.onSubmitForget(e)}>
        <div className="container">
          <div className="card-login">
            <div className="card-header-login text-center">
              <h4 className="pt-2">แก้ไขรหัสผ่าน</h4>
            </div>
            <div className="card-body-login">
              <Stepper
                alternativeLabel
                activeStep={this.state.activeStep}
                connector={<ColorlibConnector />}
              >
                {this.state.steps.map(label => (
                  <Step key={label}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}>
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-10 align-self-center mb-3">
                    {this.getStepContent(this.state.activeStep)}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer-login">
              <div className="row justify-content-center">
                {this.state.activeStep === 3 ? (
                  <Link
                    to={`/`}
                    className="col-12 btn color-button font-weight-bolder col-12 col-md-10"
                  >
                    เข้าสู่ระบบ
                  </Link>
                ) : (
                  <div className="col-12 col-md-10">
                    <button
                      className="btn btn-success col-12"
                      disabled={this.state.statusButton}
                    >
                      {this.state.statusButton ? <Spinners /> : <></>}
                      ยืนยัน
                    </button>
                    <Link
                      to={`/`}
                      className="btn btn-secondary font-weight-bolder col-12 mt-2"
                    >
                      กลับหน้าแรก
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    otp: state.otp,
  };
}

export default connect(mapStateToProps, {
  forgetpassOTP,
  validateForgetOTP,
  clearValidateOTP,
  forceChange,
  login,
})(ForgetPass);
